import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { AdminOrderShipmentMethodResponse } from './admin-order-shipment-method.response';
import { AdminOrderShippingAddressResponse } from './admin-order-shipping-address.response';
import {
  OrderShipmentRefundSummaryResponse,
  ShipmentStatus,
} from '@web/shared/module/shop';
import { Guid, Nillable } from '@web/utils';
import { AdminShipmentSizeType } from '../../enums/admin-shipment-size-type';
import { AdminOrderShipmentContextOperationsResponse } from './admin-order-shipment-context-operations.response';
import { AdminOrderShipmentComponentGroupResponse } from './admin-order-shipment-component-group.response';

@jsonObject
export class AdminOrderShipmentResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly status!: ShipmentStatus;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly scheduledShippingDate?: Nillable<Date>;

  @jsonMember(String)
  public readonly comment?: Nillable<string>;

  @jsonMember(String)
  public readonly packageSize!: AdminShipmentSizeType;

  @jsonMember(String)
  public readonly trackingUrl?: Nillable<string>;

  @jsonMember(AdminOrderShipmentContextOperationsResponse)
  public readonly contextOperations!: AdminOrderShipmentContextOperationsResponse;

  @jsonMember(AdminOrderShipmentMethodResponse)
  public readonly method!: AdminOrderShipmentMethodResponse;

  @jsonMember(AdminOrderShippingAddressResponse)
  public readonly address!: AdminOrderShippingAddressResponse;

  @jsonMember(OrderShipmentRefundSummaryResponse)
  public readonly refundSummary?: Nillable<OrderShipmentRefundSummaryResponse>;

  @jsonArrayMember(AdminOrderShipmentComponentGroupResponse)
  public readonly componentGroups?: Nillable<
    AdminOrderShipmentComponentGroupResponse[]
  >;
}
